import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { apiUrl } from '@/utils/api'

const PageTracker = () => {
  const location = useLocation()

  useEffect(() => {
    // Track page view
    const trackPageView = async () => {
      try {
        await fetch(apiUrl('/api/tracking/pageview'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            page: location.pathname,
            title: document.title,
            referrer: document.referrer,
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent
          })
        })
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.debug('Page tracking failed:', error)
      }
    }

    // Track after a small delay to ensure the page is fully loaded
    const timer = setTimeout(trackPageView, 500)
    
    return () => clearTimeout(timer)
  }, [location.pathname])

  // Render tracking pixel
  return (
    <img 
      src={apiUrl('/api/tracking/pixel.gif')} 
      alt="" 
      style={{ 
        position: 'absolute', 
        width: '1px', 
        height: '1px', 
        opacity: 0,
        pointerEvents: 'none'
      }}
      onError={() => {
        // Silently handle errors
      }}
    />
  )
}

export default PageTracker
